// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: WxOrg8T5g_M6
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicNewApplicationReceived.module.css"; // plasmic-import: WxOrg8T5g_M6/css
import CheckSvgIcon from "./icons/PlasmicIcon__CheckSvg"; // plasmic-import: NNWdipNv4a0I/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: cdQ-QsSHJP16/icon

createPlasmicElementProxy;

export const PlasmicNewApplicationReceived__VariantProps = new Array();

export const PlasmicNewApplicationReceived__ArgProps = new Array(
  "title",
  "buttonLabel"
);

const $$ = {};

function PlasmicNewApplicationReceived__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__o8Rsf)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__kl2W
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__by0U8)}>
            <div className={classNames(projectcss.all, sty.freeBox__fWjjm)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg___1GsNa)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__mdIa)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__fJy7Y)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg__czCll)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__aVjCc)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__zAdpa)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg___2IYqO)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__g2ZyE)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__bVKfZ)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                >
                  <CheckSvgIcon
                    className={classNames(projectcss.all, sty.svg__t6Wr)}
                    role={"img"}
                  />
                </div>
              </div>
            </div>
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__ujoTl)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__um9Zw
                )}
              >
                {"Account Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__c4LQ
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__d6Py
                )}
              >
                {"Plan Information"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__z2Tgb
                )}
              >
                {"Confirm Identity"}
              </div>
            </Stack__>
            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__uFrNc)}>
                {renderPlasmicSlot({
                  defaultContents: "Application Received!",
                  value: args.title,
                  className: classNames(sty.slotTargetTitle)
                })}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__aCkff
                )}
              >
                {
                  "Your information has been submitted and is currently being processed by our system. We will send you an email shortly with an update on your application status."
                }
              </div>
              <div
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames(projectcss.all, sty.continueButton)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__elfwv)}>
                  {renderPlasmicSlot({
                    defaultContents: "Continue",
                    value: args.buttonLabel,
                    className: classNames(sty.slotTargetButtonLabel)
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "vertStack",
    "continueButton"
  ],

  lineStack: ["lineStack", "circle", "circle2", "circle3", "circle4"],
  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  vertStack: ["vertStack", "continueButton"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewApplicationReceived__ArgProps,
          internalVariantPropNames: PlasmicNewApplicationReceived__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNewApplicationReceived__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNewApplicationReceived";
  } else {
    func.displayName = `PlasmicNewApplicationReceived.${nodeName}`;
  }
  return func;
}

export const PlasmicNewApplicationReceived = Object.assign(
  // Top-level PlasmicNewApplicationReceived renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    vertStack: makeNodeComponent("vertStack"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicNewApplicationReceived
    internalVariantProps: PlasmicNewApplicationReceived__VariantProps,
    internalArgProps: PlasmicNewApplicationReceived__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicNewApplicationReceived;
/* prettier-ignore-end */
